import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl',
  standalone: true,
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}
  transform(url: string | null): SafeResourceUrl | null {
    // The URL is returned by a trusted external API that we control.
    // It is considered safe to bypass Angular's sanitization here.
    return url ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : null;
  }
} 